__turbopack_context__.v({
  "token": "monster-view-module__nOPmgG__token",
  "tokenWrapper": "monster-view-module__nOPmgG__tokenWrapper",
  "wrapper": "monster-view-module__nOPmgG__wrapper",
});
